export interface UserInput {
    Username: string;
    Password: string;
}

export const userInputDefault: UserInput = {
    Username: '',
    Password: '',
};

export interface IAiDataExtractorUploadInput {
    title: string,
    description: string
}

export interface IAiDataExtractorUploadRequest extends IAiDataExtractorUploadInput{
    uploader: string,
    origin: string,
    projectId: string
    projectName: string
}

export const  aiDataExtractorUploadInputDefault: IAiDataExtractorUploadInput = {
    title: '',
    description: ''
}

